<template>
    <div class="az-form-content">
        <ModalResponderEsclarecimentoImpugnacao
                v-if="modalResposta"
                v-model="modalResposta"
                @fecharModal="fecharModalEsclarecimento"
                :item="impugnacaoSelecionado"
                tipo="Impugnação"
                :esclarecimento="false"
                :convidado="false"
        />
        <ModalVisualizarRespostaEsclarecimentoImpugnacao
                v-if="modalVisualizacao"
                v-model="modalVisualizacao"
                @fecharModalVisualizacao="fecharModalVisualizacao"
                :item="impugnacaoSelecionado"
        />
        <ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao
                v-if="modalConvidarUsuario"
                v-model="modalConvidarUsuario"
                :esclarecimento-impugnacao-id="impugnacaoSelecionado ? impugnacaoSelecionado.id : null"
                @convite-enviado="buscarImpugnacoes"
        />
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Impugnações</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="impugnacoes.length > 0"
                                  :headers="colunas"
                                  :items="impugnacoes"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                    </span>
                                    <span v-else-if="props.item.nomeRazaoSocial">
                                      {{ props.item.nomeRazaoSocial }}
                                    </span>
                                    <span v-else>
                                      --
                                    </span>
                                </td>
                                <td class="d-inline-block text-truncate max-25">{{ props.item.assunto }}</td>
                                <td>
                                    <span>{{ possuiAnexo(props.item) }}</span>
                                </td>
                                <td :class="{'status-rascunho' : props.item.situacao === 'RASCUNHO'}">{{ props.item.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao) }}</td>
                                <td class="table-actions">
                                    <div>
                                        <a v-if="props.item.relatorioUri" :href="criarLinkDownload(props.item.relatorioUri)" target="_blank"
                                           title="Download Relatório" class="az-action-link-icon">
                                          <v-icon>get_app</v-icon>
                                        </a>
                                        <a v-if="props.item.situacao != 'RASCUNHO'" title="Responder" @click="abrirModalResposta(props.item)">
                                            <v-icon>reply</v-icon>
                                        </a>
                                        <a title="Convidar para Responder" v-if="exibirConvidarUsuario && props.item.situacao != 'RASCUNHO'" @click="abrirModalConvidarUsuario(props.item)">
                                            <v-icon>person_add</v-icon>
                                        </a>
                                        <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                            <v-icon>search</v-icon>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-flex xs12 sm12 d-flex v-if="!impugnacoes.length && !editando">
                        <az-ops title="Nenhuma impugnação encontrada."
                                message="Este processo não possui nenhuma impugnação até o momento."
                        ></az-ops>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {actionTypes, tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
    import ModalResponderEsclarecimentoImpugnacao from './Modal/ModalResponderEsclarecimentoImpugnacao'
    import ModalVisualizarRespostaEsclarecimentoImpugnacao
        from './Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao'
    import ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao from './Modal/ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao'
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'LicitacaoImpugnacaoTabela',
        components: {ModalVisualizarRespostaEsclarecimentoImpugnacao, ModalResponderEsclarecimentoImpugnacao, ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao},
        inject: ['$validator'],
        props: ['editando', 'impugnacoes'],
        data() {
            return {
                modalResposta: false,
                modalVisualizacao: false,
                modalConvidarUsuario: false,
                impugnacaoSelecionado: null,
                licitacaoId: undefined,
                repository: 'repo1:licitacao',
                tiposSituacaoEsclarecimentoImpugnacao
            }
        },
        computed:{
            ...mapState(['licitacao', 'parametros']),
            colunas(){
                return this.criarColunas(6,
                    ['Data','Empresa','Assunto Impugnação','Anexo','Situação', 'Ações'],
                    [],
                    [false,false,false,false,false, false],
                    ['left','left','left','left','left','center'],
                    ['15%','15%','25%','10%','20%', '15%'],
                    'primary--text')
            },
            exibirConvidarUsuario(){
              return this.parametros.propriedadesLicitacao.habilitarConviteResponderEsclarecimentoImpugnacao && this.licitacao.registroPreco === 'S'
            }
        },
        methods: {
            ...mapActions([
                actionTypes.BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO,
                actionTypes.CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO
            ]),
            possuiAnexo(item){
                if(item.arquivoUri){
                    return 'Sim'
                }else{
                    return 'Não'
                }
            },
            abrirModalVisualizacao(item){
                this.modalVisualizacao = true
                this.impugnacaoSelecionado = item
            },
            abrirModalResposta(item){
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                  return
                }

                if(!this.licitacao.esclarecimentoImpugnacao){
                  this.mostrarNotificacaoErro("Não é possível responder, habilite a funcionalidade de esclarecimento e impugnação!")
                  return
                }
                this.modalResposta = true
                this.impugnacaoSelecionado = item
            },
            abrirModalConvidarUsuario(item){
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                  return
                }
                if(!this.licitacao.esclarecimentoImpugnacao){
                  this.mostrarNotificacaoErro("Não é possível convidar, habilite a funcionalidade de esclarecimento e impugnação!")
                  return
                }
                this.modalConvidarUsuario = true
                this.impugnacaoSelecionado = item
            },
            buscarImpugnacoes(){
                this.$emit('buscarImpugnacoes')
            },
            fecharModalEsclarecimento(){
                this.modalResposta = false
                this.impugnacaoSelecionado = null
                this.$emit('buscarImpugnacoes')
            },
            fecharModalVisualizacao(){
                this.modalVisualizacao = false
                this.impugnacaoSelecionado = null
                this.$emit('buscarImpugnacoes')
            }
        }
    }
</script>

<style scoped>
.teste {
    padding-bottom: 100px !important;
}

.table-status__error i {
    font-size: 18px;
    color: #d79641;
}

.table-dados-esclarecimentos td {
    color: #777;
}

.status-rascunho{
  color: #F54927 !important;
}

.table-dados-esclarecimentos {
    padding-bottom: 60px;
}

@media (max-width: 720px) {
    .table-dados-esclarecimentos td:nth-of-type(1):before {
        display: none;
    }

    .table-dados-esclarecimentos td:nth-of-type(2):before {
        content: "Tipo:";
    }

    .table-dados-esclarecimentos td:nth-of-type(3):before {
        content: "Data:";
    }

    .table-dados-esclarecimentos td:nth-of-type(4):before {
        content: "Nome:";
    }

    .table-dados-esclarecimentos td:nth-of-type(5):before {
        display: none;
    }
}
</style>
